import React, { Component } from "react";
import "./CarFormDetail.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
const imgdir = process.env.REACT_APP_IMG_FOLDER;

class CarFormDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageStyle: "ImageHeader"
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = event => {
    const { scrollY } = window;
    const { active } = this.state;
    if (scrollY < 70) {
      this.setState({ imageStyle: "ImageHeader" });
    } else {
      this.setState({ imageStyle: "ImageHeaderSmall" });
    }
  };

  handleChange = event => {
    this.setState({ value: event.target.value });
  };

  render() {
    return (
      <div
        className={
          this.state.imageStyle == "ImageHeader"
            ? "CarFormDetail"
            : "CarFormDetailTop"
        }
      >
        <Grid
          container
          spacing={3}
          xs={12}
          sm={9}
          style={{ marginLeft: "20px" }}
        >
          <Grid item xs={12} sm={12}>
            <div className="CarFormBox">
              <div className="CarFormTitle2">Detalle de la Reserva</div>

              <div style={{ fontSize: "0.8rem", marginTop: "15px" }}>
                Vehículo que estas reservando:
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  marginTop: "20px"
                }}
              >
                <div
                  style={{
                    width: "40%"
                  }}
                >
                  <div
                    style={{
                      fontFamily: "ToyotaBold",
                      fontSize: "1.3rem",
                      marginTop: "10px"
                    }}
                  >
                    {this.props.car.modelo}
                  </div>
                  <div
                    style={{
                      fontFamily: "ToyotaRegular",
                      fontSize: "1.2rem"
                    }}
                  >
                    {this.props.car.nombre}
                  </div>
                </div>
                <div className="FormCarImgDiv">
                  <div
                    className="CarFormDetailImage"
                    style={{
                      backgroundImage:
                        "url(" + imgdir + this.props.car.foto1 + ")"
                    }}
                  ></div>
                </div>
              </div>
            </div>
            <div className="CarFormBox">
              <div style={{ display: "flex" }}>
                <div style={{ width: "70%", fontSize: "0.9rem" }}>
                  Valor del Vehiculo
                </div>
                <div style={{ width: "30%", textAlign: "right" }}>
                  ${this.props.car.precio}
                </div>
              </div>
              <br />
              <div style={{ display: "flex" }}>
                <div style={{ width: "70%", fontSize: "0.9rem" }}>
                  Valor del Patentamiento con Prana
                </div>
                <div style={{ width: "30%", textAlign: "right" }}>
                  ${this.props.car.patentamiento}
                </div>
              </div>
              <br />
              <div className="CarFormLine"></div>
              <div style={{ display: "flex", fontFamily: "ToyotaBold" }}>
                <div style={{ width: "70%", fontSize: "0.9rem" }}>TOTAL</div>
                <div style={{ width: "30%", textAlign: "right" }}>
                  $
                  {parseInt(this.props.car.patentamiento) +
                    parseInt(this.props.car.precio)}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  fontFamily: "ToyotaBold",
                  backgroundColor: "#ec1c24",
                  marginTop: "10px",
                  marginLeft: "-10px",
                  padding: "10px",
                  color: "white",
                  marginBottom: "30px"
                }}
              >
                <div style={{ width: "70%", fontSize: "0.9rem" }}>
                  MONTO DE RESERVA
                </div>
                <div style={{ width: "30%", textAlign: "right" }}>
                  ${this.props.reserva}
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}
export default CarFormDetail;
